/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import useAPIHandler from '../../../hook/use-api-handler';
import useSnackbar from '../../../hook/use-snakbar';
import { getDateProperFormatForInput } from '../../../utils/common';
import { logger } from '../../../utils/logger';
import { GRATUITY_INITIAL_STATE } from './gratuity-constant';
import { gratuitySchema } from './gratuity-validation';

const useGraturityService = () => {
    const {
        snackbarVisible,
        snackbarMessage,
        // snackbarDuration,
        openSnackbar,
        closeSnackbar,
        snackColor,
    } = useSnackbar();
    const { fetchData } = useAPIHandler();
    const [gratuityInfo, setGratuityInfo] = useState(GRATUITY_INITIAL_STATE);
    const [gratuityInfoData, setGratuityInfoData] = useState({});
    const [errors, setErrors] = useState({});
    const [isGratuityEnabled, setIsGratuityEnabled] = useState(null);
    const [loading, setLoading] = useState(false);
    const [statutoryGratuityCreateUpdateloading, setstatutoryGratuityCreateUpdateloadingLoading] = useState(false);
    const [setOpenPtaxModal, setOpenStatutoryPTAXModal] = useState(false);

    const handleOpenStatutoryPtaxModal = () => {

        setOpenStatutoryPTAXModal(true)
    };
    const handleCloseStatutoryPtaxModal = () => setOpenStatutoryPTAXModal(false);
    const fetchGratuityData = async () => {
        try {
            setLoading(true);
            const result = await fetchData({
                url: '/gratuity',
                method: 'GET'
            });
            if (result) {
                const payloadData = { ...result?.data, coverage_date: getDateProperFormatForInput(result?.data?.coverage_date) }
                logger.log(payloadData?.status,"payloaddata")
                setIsGratuityEnabled(payloadData?.status);
                setGratuityInfo(payloadData);
                setGratuityInfoData(payloadData)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }
    logger.log(isGratuityEnabled,"isGratuityEnabled")
    const handleChange = async (e, name, customOption = {}) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        } else if (typeof e === 'object' && e.id) {
            value = e.id;
        }

        if (customOption.formateFn) {
            value = customOption.formateFn(value)

        }
        setGratuityInfo((prevInfo) => ({
            ...prevInfo,
            [name]: value,
        }));
        const fieldSchema = gratuitySchema.extract(name);
        if (fieldSchema) {
            const { error } = fieldSchema.validate(value);
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: error ? error.details[0].message : undefined,
            }));
        }
    };

    const handleSubmit = async () => {
        const {
            gratuity_act_no,
            coverage_date,
            gratuity_type,
            // eslint-disable-next-line no-unused-vars
            status = true,
        } = gratuityInfo || {};
        let error = null;
        if (isGratuityEnabled) {

            error = gratuitySchema.validate({
                gratuity_act_no,
                coverage_date,
                gratuity_type,
            }, {
                abortEarly: false
            })?.error;
        }
        if (error && error?.details?.length > 0) {
            const validationErrors = error.details.reduce((acc, err) => {
                const pathname = err.path.join(".");
                acc[pathname] = err.message;
                return acc;
            }, {});
            setErrors(validationErrors);
        } else {
            setErrors({})
            try {
                setstatutoryGratuityCreateUpdateloadingLoading(true);
                const url = `/gratuity`;
                const payload = {
                    url: url,
                    method: 'POST',
                    data: {
                        // gratuity_act_no,
                        gratuityActNo: gratuity_act_no,
                        coverageDate: coverage_date,
                        gratuityType: gratuity_type,
                        status: isGratuityEnabled
                    }
                }
                if (gratuityInfo?.orgId) {
                    payload.data.status = true
                }
                const response = await fetchData(payload);
                if (response.status === 'success') {

                    fetchGratuityData()
                    openSnackbar({ message: "Gratuity updated successfully!" });
                }
                handleCloseStatutoryPtaxModal()

                setstatutoryGratuityCreateUpdateloadingLoading(false)
            } catch (error) {
                if (error?.type === "JoiValidationError") {
                    const errorsAll = {};
                    error?.errors?.reduce((acc, curr) => {
                        const { field, message } = curr;

                        errorsAll[field] = message;

                        return acc;
                    });
                    openSnackbar({
                        message:
                            Object.keys(errorsAll).length > 0
                                ? "Validation Error!"
                                : "Something went wrong!",
                        color: "danger",
                    });
                    setErrors(errorsAll);
                }
                setstatutoryGratuityCreateUpdateloadingLoading(false)

            }
        }
    }



    const handleToggleGratuity = (newChecked) => {
        setIsGratuityEnabled(newChecked);
        setGratuityInfo(GRATUITY_INITIAL_STATE);
        logger.log(isGratuityEnabled,"gobinda")
    };

    let selectValue;
    if (gratuityInfo.gratuity_type === 1) {
        selectValue = 'Gratuity Run By Under Labour ACT';
    } else if (gratuityInfo.gratuity_type === 2) {
        selectValue = 'Gratuity Run By Any Insurance Company';
    }

    useEffect(() => {
        fetchGratuityData();
    }, []);
    return {
        loading,
        gratuityInfoData,
        gratuityInfo,
        handleChange,
        errors,
        isGratuityEnabled,
        selectValue,
        handleSubmit,
        statutoryGratuityCreateUpdateloading,
        setOpenPtaxModal,
        handleCloseStatutoryPtaxModal,
        handleOpenStatutoryPtaxModal,
        snackbarVisible,
        closeSnackbar,
        snackbarMessage,
        snackColor,
        setstatutoryGratuityCreateUpdateloadingLoading,
        handleToggleGratuity,
    }
}

export default useGraturityService